module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/icons/download-9e9f991f0a985a8ea323a63536a8c602.svg";